const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const EXCEPTION_EVENT_WINDOW = 1 * DAY;
export const FAULT_DETAIL_HISTORY = 365 * DAY;
